export * from './date';
export * from './number';
export * from './select';
export * from './semantic';
export * from './tag';
export * from './text';
export * from './textarea';

import date from './date';
import number from './number';
import select from './select';
import semantic from './semantic';
import tag from './tag';
import text from './text';
import textarea from './textarea';

import {AttributeTemplateType} from '../schema';

export default {
	[AttributeTemplateType.DATE]: date,
	[AttributeTemplateType.NUMBER]: number,
	[AttributeTemplateType.SELECT]: select,
	[AttributeTemplateType.SEMANTIC]: semantic,
	[AttributeTemplateType.TAG]: tag,
	[AttributeTemplateType.TEXT]: text,
	[AttributeTemplateType.TEXTAREA]: textarea,
};
